import * as React from "react";

import { useTheme, useMediaQuery } from "@mui/material";

import { ObservationStepMobile } from "./ObservationStepMobile";
import { ObservationStepDesktop } from "./ObservationStepDesktop";

export function ObservationStep() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return isMobile ? <ObservationStepMobile /> : <ObservationStepDesktop />;
}
